import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat,findArrayObject, amountFormatOnly,isEmpty, getDateInStringDDMMMYYYY,numberWithCommas,checkNumberOnly,replaceCommas,sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../../components/Dialog/Dialog';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  getTripDetailsOnly,
  updateTripStatus,
  editVendorExpense,
  addVendorExpense
} from "../../../store/actions/tripActionCreator";
import {
  updateCreateVehicleOpen,
} from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../../components/css/inputs'
import {
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS,
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  PAYMENT_CHIPS,
  TRIP_ACTIONS_FORM_LABELS
} from "../../../store/constants";
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import addStyles from '../../components/css/addEditTrip';
import AddSupplier from '../../pages/Suppliers/AddSupplier';
import AddDriver from '../../components/AddDialogComponent/AddDialogComponent';
import { trackDwebEvent } from '../../analytics';
import clsx from 'clsx';
import { updateTrip } from '../../../store/actions/tripActionCreator';
import { isFunction } from '../../../utils/utils';
const filter = createFilterOptions({
  limit: 20,
  matchFrom: 'any'
});
const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  error: {
    color: 'red',
    marginBottom: 8
  }
}));
const AddEditFrieghtAmount = (props) => {
  const formClasses = useStyles();
  const inputClasses = inputStyles();
  const classes = addStyles();
  let submit
  const {
    user,
    onConfirm,
    open,
    onClose,
    onSave,
    action,
    location,
    vehicle,
    defaultNumber,
    editData,
    dispatchAddVendorExpense,
    dispatchEditVendorExpense,
    selectedTrip,
    updateJourney,
    freight,
    dispatchUpdateTrip,
    ...other
  } = props;
  let fleetOwnerId = user.userInfo.entityId;
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let journey = user.singleTripData ? user.singleTripData : {};
  let tripDetails = selectedTrip && selectedTrip.id?selectedTrip:null;
  let tripId = tripDetails && tripDetails.id?tripDetails.id:path[path.length-1];
  let vendorId = journey && journey.vendor && journey.vendor.vendorId ?journey.vendor.vendorId:0;
  let transactions = tripDetails && tripDetails.transactions && tripDetails.transactions.freight ? tripDetails.transactions.freight :[];
  const [dialogopen, setDialogOpen] = React.useState(open);
  const [freightAmount, setFreightAmount] = useState(tripId && transactions && transactions.totalAmount ? numberWithCommas(parseInt(transactions.totalAmount)) : '');
  const [customerBillingType, setCustomerBillingType] = useState(tripId && tripDetails && tripDetails.invoicingType ? tripDetails.invoicingType : 'Fixed');
  const [customerTotalUnits, setCustomerTotalUnits] = useState(tripId && tripDetails && tripDetails.invoicingCalc && tripDetails.invoicingCalc.totalUnits ? tripDetails.invoicingCalc.totalUnits : '');
  const [customerUnitPrice, setCustomerUnitPrice] = useState(tripId && tripDetails && tripDetails.invoicingCalc && tripDetails.invoicingCalc.unitPrice ? numberWithCommas(tripDetails.invoicingCalc.unitPrice) : '');
  const validate = values => {
    const errors = {};
    if (!values.freightAmount && values.customerBillingType == 'Fixed' ) {
      errors.freightAmount = 'Freight Required';
    }
    if (values.freightAmount && values.customerBillingType == 'Fixed'  && !checkNumberOnly(replaceCommas(values.freightAmount))) {
      errors.freightAmount = 'Invalid Freight';
    }
    if (values.freightAmount && values.customerBillingType == 'Fixed' && checkNumberOnly(replaceCommas(values.freightAmount)) && Number(replaceCommas(values.freightAmount))<=0) {
      errors.freightAmount = 'Freight cannot be zero or negative';
    }
    if (!values.customerBillingType) {
      errors.customerBillingType = 'Required';
    }
    if (!values.customerUnitPrice && values.customerBillingType != 'Fixed') {
      errors.customerUnitPrice = 'Required';
    }
    if (values.customerUnitPrice && values.customerBillingType != 'Fixed' && !checkNumberOnly(replaceCommas(values.customerUnitPrice))) {
      errors.customerUnitPrice = 'Invalid Rate';
    }
    if (values.customerUnitPrice && values.customerBillingType != 'Fixed' && checkNumberOnly(replaceCommas(values.customerUnitPrice))&& Number(replaceCommas(values.customerUnitPrice))<=0) {
      errors.customerUnitPrice = 'Rate cannot be zero or negative';
    }
    if (!values.customerTotalUnits && values.customerBillingType != 'Fixed') {
      errors.customerTotalUnits = 'Required';
    }
    if (values.customerTotalUnits && values.customerBillingType != 'Fixed' && !checkNumberOnly(replaceCommas(values.customerTotalUnits))) {
      errors.customerTotalUnits = 'Invalid Units';
    }
    if (values.customerTotalUnits && values.customerBillingType != 'Fixed' && checkNumberOnly(replaceCommas(values.customerTotalUnits)) && Number(replaceCommas(values.customerTotalUnits))<=0) {
      errors.customerTotalUnits = 'Units cannot be zero or negative';
    }
    return errors;
  };
  const handleConfirm = (e) => {
    fetchTripDetails()
    onSave(false);
  }
  const handleClose = (status) => {
    fetchTripDetails()
    onClose(false);
  };
  const fetchTripDetails = ()=>{
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  } 
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    //window.alert(JSON.stringify(values, 0, 2));
    if (tripId) {
      let data = {
        fleetOwnerId: fleetOwnerId,
        totalAmount: Number(replaceCommas(values.freightAmount))
    }
    data['billingType'] = values.customerBillingType;
    if (values.customerBillingType != 'Fixed') {
        data['billingDetails'] = { unitPrice: Number(replaceCommas(values.customerUnitPrice)), totalUnits: Number(values.customerTotalUnits) }
        data['totalAmount'] = Number(values.customerUnitPrice ? replaceCommas(values.customerUnitPrice) : 0) * Number(values.customerTotalUnits ? values.customerTotalUnits : 0);
    }
      dispatchUpdateTrip(tripId,data, (data) => {
        if (data && data.status && data.status.code && data.status.code === 200) {
          sendSucces("Freight Amount Updated Successfully!");
          handleConfirm();
        }
      }, () => {

      })
    } else {
        
    }
  };
  useEffect(() => {
  }, []);
  const getFormFields = (values) => {
    let {customerBillingType } = values;
    let customerUnitsPriceLabel = "";
    let customerTotalUnitsLabel = "";
    let freightAmountCostCard = "Freight";
    if (customerBillingType === 'Per Tonne') {
        customerUnitsPriceLabel = 'Rate Per Tonne';
        customerTotalUnitsLabel = 'Total Tonnage';
        freightAmountCostCard += " (Rate * Number of Tonnes)"

    } else if (customerBillingType === 'Per KG') {
        customerUnitsPriceLabel = 'Rate Per Kg';
        customerTotalUnitsLabel = 'Total Kg'
        freightAmountCostCard += " (Rate * Number of Kg)"

    } else if (customerBillingType === 'Per KM') {
        customerUnitsPriceLabel = 'Rate Per Km';
        customerTotalUnitsLabel = 'Total Km'
        freightAmountCostCard += " (Rate * Number of Km)"
    } else if (customerBillingType == "Per Trip") {
      customerUnitsPriceLabel = 'Rate Per Trip'
      customerTotalUnitsLabel = 'Total Trips'
      freightAmountCostCard += " (Rate * Number of Trips)"
    } else if (customerBillingType == "Per Day") {
      customerUnitsPriceLabel = 'Rate Per Day'
      customerTotalUnitsLabel = 'Total Days'
      freightAmountCostCard += " (Rate * Number of Days)"
    } else if (customerBillingType == "Per Hour") {
      customerUnitsPriceLabel = 'Rate Per Hour'
      customerTotalUnitsLabel = 'Total Hours'
      freightAmountCostCard += " (Rate * Number of Hours)"
    } else if (customerBillingType == "Per Litre") {
      customerUnitsPriceLabel = 'Rate Per Litre'
      customerTotalUnitsLabel = 'Total Litres'
      freightAmountCostCard += " (Rate * Number of Litres)"
    } else if (customerBillingType == "Per Bag") {
      customerUnitsPriceLabel = "Rate Per Bag"
      customerTotalUnitsLabel = "Total Bags"
      freightAmountCostCard += "(Rate * Number of Bags)"
    }
    let commonFields = [
        {
            size: 12,
            visible: true,
            inline: false,
            field: (<Radios
              label="Billing Type"
              name="customerBillingType"
              required={true}
              formControlProps={{
                margin: 'normal',
                className: classes.billingTypeRadio,
                fullWidth: true
              }}
              onChange={(e) => { setCustomerBillingType(e.target.value) }}
              formControlLabelProps={{
                className: classes.supplierBillingTypeLabel
              }}
              formLabelProps={{}}
              radioGroupProps={{ row: true }}
              data={[
                { value: 'Fixed', label: 'Fixed' },
                { value: 'Per Tonne', label: 'Per Tonne' },
                { value: 'Per KG', label: 'Per KG' },
                { value: 'Per KM', label: 'Per KM' },
                { value: 'Per Trip', label: 'Per Trip' },
                { value: 'Per Day', label: 'Per Day' },
                { value: 'Per Hour', label: 'Per Hour' },
                { value: 'Per Litre', label: 'Per Litre' },
                { value: 'Per Bag', label: 'Per Bag' }
              ]}
            />),
        },
        {
          size: 12,
          visible: customerBillingType !== 'Fixed',
          inline: false,
          field: (
            <TextField
              label={customerUnitsPriceLabel}
              placeholder={customerUnitsPriceLabel}
              name="customerUnitPrice"
              margin="normal"
              onChange={(e) => { setCustomerUnitPrice(numberWithCommas(e.target.value)) }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              fullWidth={true}
              variant="outlined"
              size="small"
              required={true}
            />
          ),
        },
        {
          size: 12,
          visible: customerBillingType !== 'Fixed',
          inline: false,
          field: (
            <TextField
              label={customerTotalUnitsLabel}
              placeholder={customerTotalUnitsLabel}
              name="customerTotalUnits"
              onChange={(e) => { setCustomerTotalUnits(e.target.value) }}
              fullWidth={true}
              variant="outlined"
              size="small"
              margin="normal"
              required={true}
            />
          ),
        },
        {
            size: 12,
            visible:customerBillingType == 'Fixed',
            field: (
              <TextField
                label={'Frieght Amount'}
                placeholder="Enter a Amount"
                name="freightAmount"
                variant="outlined"
                size="small"
                margin="normal"
                onChange={(e)=>setFreightAmount(numberWithCommas(e.target.value))}
                fieldProps={{
                  parse: value => value && numberWithCommas(value)
                }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                }}
                required={true}
              />
            ),
        },
        {
          size: 12,
          visible: customerBillingType !== 'Fixed',
          inline: false,
          field: (
            <Paper className={clsx(classes.unitCard, classes.truckHireCard)}>
              <div><span className={classes.unitDesc}>{freightAmountCostCard}</span></div>
              <div><span className={classes.unitAmount}>{numberFormat(Number(values.customerTotalUnits) * Number(replaceCommas(values.customerUnitPrice)))}</span></div>
            </Paper>
          ),
        }
    ];
    return commonFields;
  }
  let initialValues = {
    freightAmount:freightAmount,
    customerBillingType: customerBillingType,
    customerTotalUnits: customerTotalUnits,
    customerUnitPrice: customerUnitPrice,
  };
  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"truck-hire-cost"}
        open={dialogopen}
      >
        <DialogTitle id={"truck-hire-cost"} onClose={handleClose}>
          {tripId?'Update Freight':'Add Freight'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={0}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />
        </TripActionDialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" className='modal-save-cta' onClick={event => submit(event)} >
            {tripId?'Update Freight':'Add Freight'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
const AddEditFrieghtAmountWithRouter = withRouter(AddEditFrieghtAmount);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchEditVendorExpense: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editVendorExpense(expenseId, request, onSuccess, onFailure)),
    dispatchAddVendorExpense: (request, onSuccess, onFailure) =>
    dispatch(addVendorExpense(request, onSuccess, onFailure)),
    dispatchUpdateTrip: (tripId, trip, onSuccess, onError) => {
      dispatch(updateTrip(tripId, trip, onSuccess, onError));
    }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditFrieghtAmountWithRouter);